import { render } from "./BookingAccommodation.vue?vue&type=template&id=adf45f38"
import script from "./BookingAccommodation.vue?vue&type=script&lang=js"
export * from "./BookingAccommodation.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "../i18n/BookingAccommodation.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fpeeristics%2Frails-frontend%2Fapp%2Fassets%2Fvue%2Fscheduling%2Fbooking%2Fcomponents%2FBookingAccommodation.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__